import { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";

import {
  getData,
  postData,
  getEditData,
  editData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "./api";

import { Per_Page_Dropdown } from "./common";
import { IDS } from "./common";
export const Context = createContext();

const AppContext = ({ children }) => {
  // const IMG_URL = "http://127.0.0.1:2206";
  // const IMG_URL = "http://192.168.16.53:2206";

  const IMG_URL = "https://aigrowthnode.profcymadev.com:2206";

  // const IMG_URL = "https://node.myindexapp.in";

  const navigate = useNavigate();

  const [shimmerLoader, setShimmerLoader] = useState(false);
  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");
  const [userdata, setUserData] = useState({});
  const [token, setToken] = useState("");
  const [isAllow, setisAllow] = useState([]);

  const minLength = 2; // Set your desired minimum length
  const maxLength = 30; // Set your desired maximum length

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const getuserData = async (id) => {
    const response = await getData(`/auth/login/${id}`, { id: id });
    await setUserData(response?.data);
    await setisAllow(response?.data.permissions);
  };

  const isTokenValid = async () => {
    const token = Cookies.get("aigrowth_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("aigrowth_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
      } else {
        setisAllow(decodedToken?.permissions);
        getuserData(decodedToken.user);
        setUsertype(decodedToken.name);
        setSignin(true);
      }
    } else {
      setisAllow([]);
      setSignin(false);
      setUsertype("");
      navigate("/");
    }
  };
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  return (
    <Context.Provider
      value={{
        getData,
        postData,
        // getEditData,
        // editData,
        editStatusData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        setisAllow,
        isAllow,
        Per_Page_Dropdown,
        toggleSidebar,
        IMG_URL,
        shimmerLoader,
        setShimmerLoader,
        // token,
        // setToken,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
